import { ApiProperty } from "@nestjs/swagger";

export class QcdefectReportRequest{
    @ApiProperty()
    workstationId?:number
    @ApiProperty()
    operationId?:number
    @ApiProperty()
    testResultId?:number;
    @ApiProperty()
    lotNumber?:string;
}

export class QcdefectItemDetailsRequest{
    @ApiProperty()
    qcId:number
}
